
<h1 mat-dialog-title class="!grid !justify-center">
  <p [ngClass]="{'text-green-700':this.alertType ==='success-btn',
    'text-yellow-700':this.alertType ==='warn-btn',
    'text-red-700':this.alertType ==='red-btn'}">{{title}}</p>
</h1>
<div mat-dialog-content class="!grid !justify-center !min-h-24">
  <p class="text-2xl font-normal tracking-wide whitespace-pre-line">{{message}}</p>
</div>
<div mat-dialog-actions class="flex flex-row justify-center content-center
  !text-white
  items-center #{!important}">
  <div [ngClass]="this.alertType" (click)="onClose()">OK</div>
</div>
